import React from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import AvatarSkeleton from "../../../components/skeletons/AvatarSkeleton";
import {Col, Row} from "antd";

export default function ClientDetailsSkeleton({close, getListing, setGetListing, id}) {
    return(
        <>
            <div>
                <div className="main_div_client_details">
                    <div className="inner_div">
                        <div className="header">
                            <h3 className={'btn-head'}><span><HeadingSkeleton height={10} maxWidth={100} /> </span><small> <HeadingSkeleton height={10} maxWidth={100} /> </small> </h3>
                        </div>

                        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                            <Col xs={24} lg={24} xl={12} md={12}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="client_info">
                                            <div className="inner_client_info">
                                                <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                <span>
                        <HeadingSkeleton height={20} maxWidth={20} />
                        </span>
                                            </div>
                                            <div className="profile">
                                                <div className="img_div">
                                                    <AvatarSkeleton width={40} height={40} avatarShape={'circle'}/>
                                                </div>
                                                <div>
                                                    <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                    <p className="para"><HeadingSkeleton height={10} maxWidth={200} /></p>
                                                </div>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <HeadingSkeleton height={20} maxWidth={20} />
                                                    <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                </div>
                                                <p>
                                                    <HeadingSkeleton height={10} maxWidth={100} />
                                                </p>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <HeadingSkeleton height={20} maxWidth={20} />
                                                    <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                                </div>

                                                <p>
                                                    <HeadingSkeleton height={10} maxWidth={100} />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} lg={24} xl={12} md={12}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="previous_session_div">
                                            <div className="header">
                                                <h5><HeadingSkeleton height={15} maxWidth={100} /></h5>
                                                <div>
                                                    <HeadingSkeleton height={10} maxWidth={10} />
                                                </div>
                                            </div>
                                            <div className="search_input">
                                                <HeadingSkeleton height={30} maxWidth={300} />
                                            </div>
                                            <div className="mt-5 client_session">
                                                <div className="previous_session_listing">
                                                    <p> <HeadingSkeleton height={10} maxWidth={100} /> <HeadingSkeleton height={10} maxWidth={100} /></p>
                                                    <div className="content_div_main">
                                                        <div className="inner_div_content">
                                                            <p>
                                                                <HeadingSkeleton height={10} maxWidth={100} />
                                                                <span className={'d-block'}>
                                                                    <HeadingSkeleton height={30} maxWidth={100} />
                                                                </span>
                                                            </p>
                                                            <div>
                                                            <span >
                                                                <HeadingSkeleton height={10} maxWidth={10} />
                                                            </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="previous_session_listing">
                                                    <p> <HeadingSkeleton height={10} maxWidth={100} /> <HeadingSkeleton height={10} maxWidth={100} /></p>
                                                    <div className="content_div_main">
                                                        <div className="inner_div_content">
                                                            <p>
                                                                <HeadingSkeleton height={10} maxWidth={100} />
                                                                <span className={'d-block'}>
                                                                    <HeadingSkeleton height={30} maxWidth={100} />
                                                                </span>
                                                            </p>
                                                            <div>
                                                            <span >
                                                                <HeadingSkeleton height={10} maxWidth={10} />
                                                            </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="previous_session_listing">
                                                    <p> <HeadingSkeleton height={10} maxWidth={100} /> <HeadingSkeleton height={10} maxWidth={100} /></p>
                                                    <div className="content_div_main">
                                                        <div className="inner_div_content">
                                                            <p>
                                                                <HeadingSkeleton height={10} maxWidth={100} />
                                                                <span className={'d-block'}>
                                                                    <HeadingSkeleton height={30} maxWidth={100} />
                                                                </span>
                                                            </p>
                                                            <div>
                                                            <span >
                                                                <HeadingSkeleton height={10} maxWidth={10} />
                                                            </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="previous_session_listing">
                                                    <p> <HeadingSkeleton height={10} maxWidth={100} /> <HeadingSkeleton height={10} maxWidth={100} /></p>
                                                    <div className="content_div_main">
                                                        <div className="inner_div_content">
                                                            <p>
                                                                <HeadingSkeleton height={10} maxWidth={100} />
                                                                <span className={'d-block'}>
                                                                    <HeadingSkeleton height={30} maxWidth={100} />
                                                                </span>
                                                            </p>
                                                            <div>
                                                            <span >
                                                                <HeadingSkeleton height={10} maxWidth={10} />
                                                            </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>
        </>
    )
}